module.exports = __webpack_public_path__ + "img/hero-lg.038da19.png";